import React from "react";
import "./Sheared_Product_card.css";
import { faEye, faHeart } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

function Sheared_Product_card({ imgSrc, productName,category, prodDiscount }) {

  const app_setup = useSelector((state) => state.master.app_setup);

  const discountPercentage =
    Number(prodDiscount) > 0
      ? Number(prodDiscount)
      : Number(app_setup?.global_discount) > 0
      ? Number(app_setup.global_discount)
      : 0;

  return (
    <>
      <Link to={`/categories?category_id=${category?.id}`}>

        <section className="Sheared_Product_card">
          {discountPercentage > 0 && (
          <div className="discount">{discountPercentage}% Off</div>
        )}
          <div className="img_content_holder">
            <div className="img_holder">
              <img
                className="Product_img"
                src={imgSrc}
                alt={"Product_img"}
              />
            </div>

            <div className="icon_holder">
              {/* <FontAwesomeIcon className="feature_icon" icon={faHeart} /> */}
              <FontAwesomeIcon className="feature_icon" icon={faEye} />
            </div>

            <div className="overlay_holder"></div>
          </div>
          <div className="text_holder">
            <p>{productName}</p>
          </div>
        </section>
      </Link>
    </>
  );
}

export default Sheared_Product_card;
